import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../../hooks/use-services.hook";
import {FieldsContainer2ColumnsBox, ProfileFieldComponent} from "../common/agency-profile-common.components";
import {useContainerMediaQueriesChecks} from "../../../../../hooks/use-container-media-queries-checks.hook";
import styled from "styled-components";
import {PriceComponent} from "../../../../../components/price/price.component";


const FieldsContainer3ColumnsBox = styled(FieldsContainer2ColumnsBox)`
    grid-template-columns: 1fr 0.5fr 0.5fr;
    ${props => props.theme.containerMediaQuery.smallScreen} {
        grid-template-columns: 1fr;
    }
`


export const AgencyAccountViewComponent: React.FC = observer(() => {
    const services = useServices();
    const mediaQuery = useContainerMediaQueriesChecks();
    const userProfile = services.user.profile;

    const hasOrganizationCredit = Boolean(services.user.profile.organizationCredit);


    const renderOrganizationCredit = () => {
        if(!hasOrganizationCredit) {
            return null;
        }

        return (
            <ProfileFieldComponent label={services.language.translate("Available credit")}
                                   value={<PriceComponent price={services.user.profile.organizationCredit!}/>}
                                   isOnLastRow={true}/>
        )
    }

    const renderContent = () => {
        return  (
            <>
                <ProfileFieldComponent label={services.language.translate("Agent username")}
                                       value={userProfile.userName}
                                       isOnLastRow={!mediaQuery.smallScreen}/>

                <ProfileFieldComponent label={services.language.translate("Organization code")}
                                       value={userProfile.organizationCode}
                                       isOnLastRow={!mediaQuery.smallScreen || !hasOrganizationCredit}/>

                {renderOrganizationCredit()}

            </>
        );
    }

    if(hasOrganizationCredit) {
        return (
            <FieldsContainer3ColumnsBox>
                {renderContent()}
            </FieldsContainer3ColumnsBox>
        )
    }

    return (
        <FieldsContainer2ColumnsBox>
            {renderContent()}
        </FieldsContainer2ColumnsBox>
    )

})